import { gql } from '@apollo/client';
/**
 * @const SendDealInviteMutation
 * @since 1.0.0
 */
export const SendDealInviteMutation = gql `
  mutation SendDealInviteMutation($input: SendDealInviteInput!) {
    sendDealInvite(input: $input)
  }
`;
